





import Vue from "vue";

export default class Tbody extends Vue {}
